import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { initializeMsal } from './app/auth.config';
import { Chart } from 'chart.js';
import Annotation from 'chartjs-plugin-annotation';

Chart.register(Annotation);

console.log('Environment production flag:', environment.production);

if (environment.production) {
  console.log('Enabling production mode');
  enableProdMode();
} else {
  console.log('Development mode - NOT enabling production mode');
}


initializeMsal()
  .then(() => {
    return bootstrapApplication(AppComponent, appConfig);
  })
  .catch((err) => {
    console.error(err);
  });
